import { useCallback, useEffect, useState } from "react";
import { getLocalStorage } from "@jti/rest-api";
import { pageRun, useDispatch, useSelector } from "@jti/store";
import { useConfig } from "@jti/ui";
import { isRestrictedSlug } from "../../helpers/functions/isRestrictedSlug";
export const SCROLL_Y_POS_STORAGE_KEY = "scrollypos";
export const PageRunner = ({ name, isInEditor }) => {
    const dispatch = useDispatch();
    const [shouldRun, setShouldRun] = useState(false);
    const hiddenPageRedirectionLayerSelector = window.document.querySelector(".protectedBodyPage");
    const config = { attributeFilter: ["class"], attributeOldValue: true };
    const isLoaded = useSelector((state) => state.loyaltyCore.isLoaded);
    const { loyaltyRestrictionWithoutRedirectionSlugUrls } = useConfig();
    const isRestricted = isRestrictedSlug(loyaltyRestrictionWithoutRedirectionSlugUrls);
    const handleScroll = useCallback(() => {
        const currentPlace = {
            scrollY: window.scrollY,
            url: window.location.href,
        };
        getLocalStorage().set(SCROLL_Y_POS_STORAGE_KEY, currentPlace);
    }, []);
    useEffect(() => {
        const observer = new MutationObserver((_, observer) => {
            setShouldRun(true);
            observer.disconnect();
        });
        if (hiddenPageRedirectionLayerSelector && !isInEditor) {
            observer.observe(hiddenPageRedirectionLayerSelector, config);
        }
        else {
            setShouldRun(true);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    useEffect(() => {
        if (shouldRun) {
            // FIXME: This should have a proper value that will indicate whether its AEM authoring or builder.io
            dispatch(pageRun({ name: name, isRestricted, isInEditor: true }));
            if ("scrollRestoration" in history) {
                history.scrollRestoration = "manual";
            }
            window.addEventListener("beforeunload", handleScroll);
            return () => window.removeEventListener("beforeunload", handleScroll);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [shouldRun]);
    useEffect(() => {
        if (isLoaded) {
            const scrollYPos = getLocalStorage().get(SCROLL_Y_POS_STORAGE_KEY, {
                url: "",
                scrollY: 0,
            });
            if (window.location.href === scrollYPos.url) {
                window.scrollTo({ top: scrollYPos.scrollY, behavior: "smooth" });
            }
        }
    }, [isLoaded]);
    return null;
};
//# sourceMappingURL=PageRunner.js.map